var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDateField(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#595959"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 1.84h-.28v-.653c0-.474-.373-.854-.833-.854-.46 0-.834.38-.834.854v.653H3.94v-.653c0-.474-.373-.854-.833-.854-.46 0-.834.38-.834.854v.653H2c-.92 0-1.667.767-1.667 1.707v8.406c0 .947.747 1.714 1.667 1.714h10c.92 0 1.667-.767 1.667-1.714V3.547c0-.94-.747-1.707-1.667-1.707z",
    transform: "translate(-152 -586) translate(121 576) translate(32 11)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#595959",
    d: "M5.833 10.313c0 .023.007.044.021.059.009.009.02.014.033.014.015 0 .028-.007.038-.017.014-.014.022-.034.022-.056 0-.019-.008-.036-.02-.049-.017-.016-.048-.005-.094.05zM3.613 10.313c0 .023.007.044.021.059.009.009.02.014.033.014.013 0 .024-.005.032-.014.015-.015.021-.036.021-.059 0-.02-.007-.038-.02-.052-.015-.015-.042-.006-.087.052zM10.28 5.753c0 .02.007.039.02.052.008.009.02.015.033.015.014 0 .026-.006.034-.015.013-.013.02-.032.02-.052 0-.022-.007-.044-.021-.059-.015-.015-.041-.006-.086.06z",
    transform: "translate(-152 -586) translate(121 576) translate(32 11)"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateField);
export default __webpack_public_path__ + "static/media/date-field.e15c0d31.svg";
export { ForwardRef as ReactComponent };